import React from "react"
import { Box, Image, Typography, Grid } from "src/UILibrary"
import { useMediaQuery } from "react-responsive"

interface Props {
  image: string
  title: string
  description: string
}

export const MeetingItem = ({ image, title, description }: Props) => {
  const isTablet = useMediaQuery({ query: "(min-width: 900px)" })

  return (
    <Grid container sx={{ mt: "20px" }}>
      {isTablet ? (
        <></>
      ) : (
        <Grid
          item
          xl={6}
          lg={6}
          md={12}
          sm={12}
          xs={12}
          sx={{ height: isTablet ? "280px" : "180px" }}
        >
          <Image
            src={image}
            sx={{
              height: isTablet ? "280px" : "180px",
              bgcolor: "divider",
              flex: 1,
              mr: isTablet ? "20px" : "0px",
            }}
            imageStyle={{ width: "100%", height: "100%" }}
          />
        </Grid>
      )}
      <Grid item xl={6} lg={6} md={6} sm={12} xs={12} sx={{ my: "auto" }}>
        <Box sx={{ mt: isTablet ? "0px" : "20px", mb: "10px", mr: isTablet ? "20px" : "0px" }}>
          <Typography.Description
            className="weight500"
            color="textPrimary"
            fontSize={isTablet ? "28px" : "20px"}
            lineHeight={isTablet ? "42px" : "20px"}
          >
            {title}
          </Typography.Description>

          <Typography.SubTitle
            className="notosans weight500"
            color="textPrimary"
            fontSize={16}
            lineHeight="24px"
            mt="10px"
            dangerouslySetInnerHTML={{ __html: description }}
          ></Typography.SubTitle>
        </Box>
      </Grid>
      {isTablet ? (
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          sx={{ height: isTablet ? "280px" : "180px" }}
        >
          <Image
            src={image}
            sx={{
              height: isTablet ? "280px" : "180px",
              bgcolor: "divider",
              flex: 1,
              mr: isTablet ? "20px" : "0px",
            }}
            imageStyle={{ width: "100%", height: "100%" }}
          />
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  )
}
